import React, { useState } from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import classNames from "classnames";
import { useGetDisputeById } from "@queries/NonRKPayInvoiceQueries";
import { Modal, Loader } from "../../../../../components";
import DisputesMenu from "../DisputesMenu";
import "./NonRKPayInvoiceDisputeHistoryModal.scss";
import { DisputeProvider } from "../../context/DisputeContext";

const NonRKPayInvoiceDisputeHistoryModal = ({ show, disputeHistory, onClose, userTimeZoneId }) => {
	const { lang } = global;
	const [selectedDisputeId, setSelectedDisputeId] = useState(null);
	const { data: dispute, isFetching: isLoadingDispute } = useGetDisputeById(selectedDisputeId, {
		enabled: !!selectedDisputeId,
	});

	const handleOnClose = () => {
		onClose();
		setSelectedDisputeId(null);
	};

	return (
		<Modal
			size="lg"
			show={show}
			onHide={handleOnClose}
			id="invoice-dispute-history-modal"
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Dispute History")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="row">
					<div className="col-xs-12 col-md-3 history-list">
						{disputeHistory?.map(item => (
							<button
								key={item.DisputeId}
								type="button"
								onClick={() => setSelectedDisputeId(item.DisputeId)}
								className={classNames("btn btn-block", {
									"btn-link": item.Id !== selectedDisputeId,
									"btn-primary active": item.Id === selectedDisputeId,
								})}
							>
								{utils.formatDate(
									new Date(`${item.DisputeDate}Z`),
									"en-US",
									userTimeZoneId,
									"dt-num",
								)}
							</button>
						))}
						{disputeHistory?.length === 0 && (
							<div className="text-center text-muted">
								{lang.t("No dispute history to display")}
							</div>
						)}
					</div>
					<div
						className={classNames("col-xs-12 col-md-9 dispute-content", {
							empty: !selectedDisputeId && !isLoadingDispute,
						})}
					>
						{!selectedDisputeId && !isLoadingDispute && (
							<div className="text-center text-muted">
								{lang.t("Select a dispute to view details")}
							</div>
						)}
						{dispute && !isLoadingDispute && (
							<DisputeProvider>
								<DisputesMenu
									isReadOnly
									dispute={dispute}
									disputeId={selectedDisputeId}
								/>
							</DisputeProvider>
						)}
						<Loader
							size="small"
							active={isLoadingDispute}
						/>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					onClick={handleOnClose}
					className="btn btn-primary"
				>
					{lang.t("Close")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

export default NonRKPayInvoiceDisputeHistoryModal;

NonRKPayInvoiceDisputeHistoryModal.propTypes = {
	show: PropTypes.bool,
	onClose: PropTypes.func,
	disputeHistory: PropTypes.arrayOf(
		PropTypes.shape({
			DisputeId: PropTypes.string.isRequired,
			DisputeDate: PropTypes.string.isRequired,
		}),
	),
	userTimeZoneId: PropTypes.string.isRequired,
};

NonRKPayInvoiceDisputeHistoryModal.defaultProps = {
	show: false,
	onClose: () => {},
	disputeHistory: [],
};
